import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TransportManagementProfileEndpoint } from '../constants/transport-management-profile-endpoint';
import { TransportManagementProfileListStateModel } from './transport-management-profile-list.state';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { PlannerProfileListSearchCriteria } from '../../../../models';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementProfileListService {
  constructor(private http: WrapperHttpService) {}

  getTransportManagementProfileList(
    searchCriteria: PlannerProfileListSearchCriteria,
  ): Observable<TransportManagementProfileListStateModel> {
    const url =
      `${API_URL}${TransportManagementProfileEndpoint.Base}${TransportManagementProfileEndpoint.Profiles}?` +
      getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<TransportManagementProfileListStateModel>(url);
  }
}
